import React from 'react';
import * as S from './all-flights-to-city-from-city.styles';

const AllFlightsCity = ({ allFlightCityLinks, headerTitle, isDweb = false }) => {
  const length = isDweb ? 3 : 2;
  let flightsCityLinks = new Array(length);
  for (let i = 0; i < length; i++) {
    flightsCityLinks[i] = [];
  }
  for (let i = 0; i < allFlightCityLinks.length; i++) {
    if (i % length == 0) {
      flightsCityLinks[0].push(allFlightCityLinks[i]);
    } else if (i % length == 1) {
      flightsCityLinks[1].push(allFlightCityLinks[i]);
    } else {
      flightsCityLinks[2].push(allFlightCityLinks[i]);
    }
  }
  return (
    <S.FlightsRoute className="flexCol">
      <S.FlightFareChart>
        <S.RouteHd className="padT5 padB5">{headerTitle}</S.RouteHd>
        <S.CityLinksWrp className="dF width100">
          {flightsCityLinks &&
            flightsCityLinks.map((cityLinks, index) => (
              <div key={index} className="flex1 flexCol alignItemsStart">
                {cityLinks &&
                  cityLinks.map((cityLink, index) => (
                    <S.CityLink key={index} href={`https://${cityLink.url}`}>
                      {cityLink.name}
                    </S.CityLink>
                  ))}
              </div>
            ))}
        </S.CityLinksWrp>
      </S.FlightFareChart>
    </S.FlightsRoute>
  );
};

export default AllFlightsCity;
